<script setup>
import {ref, inject} from "vue";
import {getNoun} from "../../../helpers/string";
import MatchMakingModal from "@/views/needs/need/matchMaking/MatchMakingModal.vue";

const need = inject('need');
const getInfo = inject('getInfo');

const matchMakingModal = ref(null);

function evaluate() {
    matchMakingModal.value?.open()
}

defineExpose({
    evaluate,
});
</script>

<template>
    <div v-if="need.recommended_startups_count" class="card-needs mb-5">
        <header class="card-needs__header">
            <h3 class="heading3 heading3--match">Recommended Solutions</h3>
        </header>

        <div class="card-needs__content">
            <div class="row">
                <div v-if="need.recommended_startups_count" class="col-12 col-md-6 mb-2">
                    <div class="card-headline">
                        <div class="card-headline__content">
                            <div class="card-needs__notification card-needs__notification--active card-needs__notification--ai" :title="need.recommended_startups_count">
                                <img :src="require('@/images/icon-gen-ai.svg')" alt="" />
                            </div>

                            <div class="text-center">
                                <div class="card-needs__plate">{{need.recommended_startups_count}} new AI {{getNoun('recommendation')}}</div>
                            </div>
                        </div>

                        <footer class="card-headline__footer">
                            <a @click="evaluate" class="link-arrow justify-content-end">Review</a>
                        </footer>
                    </div>
                </div>

                <div v-if="false" class="col-12 col-md-6 mb-2">
                    <div class="card-headline">
                        <div class="card-headline__content">
                            <div class="card-needs__notification card-needs__notification--active" title="6">
                                <img src="https://app2.dev.switchpitch.com/img/global.e72ae145.png" alt="" />
                            </div>

                            <div class="text-center">
                                <div class="card-needs__plate">NEA sent 6 solutions</div>
                            </div>
                        </div>
                        <footer class="card-headline__footer">
                            <a href="#" class="link-arrow justify-content-end">Review</a>
                        </footer>
                    </div>
                </div>
            </div>
        </div>

        <MatchMakingModal
            ref="matchMakingModal"
            @updated="getInfo"
        />
    </div>
</template>
